import { render, staticRenderFns } from "./ModalImportDocument.vue?vue&type=template&id=53451b99&scoped=true&"
import script from "./ModalImportDocument.vue?vue&type=script&lang=js&"
export * from "./ModalImportDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53451b99",
  null
  
)

export default component.exports